var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(i){return _c('v-row',{key:i,staticClass:"align-center no-gutters"},[_c('v-col',[_c('v-skeleton-loader',{attrs:{"type":"list-item","height":"48"}})],1),_c('v-col',{attrs:{"cols":"auto"}},[_c('v-skeleton-loader',{staticClass:"mr-3",attrs:{"type":"button","height":"24","width":"24"}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }